'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

require('keen-slider/keen-slider.min.css');

var _keenSlider = require('keen-slider');

var _keenSlider2 = _interopRequireDefault(_keenSlider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var next = el.querySelector('.car-Indicators_Indicator-next');
  var prev = el.querySelector('.car-Indicators_Indicator-previous');

  setupObserver();

  function setupObserver() {
    var observer = new MutationObserver(function () {
      var swiperWrapper = el.querySelector('.lion-rewards-list');
      var swiperItems = el.querySelectorAll('.lion-reward-item');
      if (swiperItems.length > 0) {
        swiperWrapper.classList.add('keen-slider');
        swiperItems.forEach(function (item) {
          item.classList.add('keen-slider__slide');
        });
        initialiseCarousel();
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      attributes: true
    });
  }

  function initialiseCarousel() {
    return new _keenSlider2.default(el.querySelector('.lion-rewards-list'), {
      duration: 500,
      mode: 'snap',
      slides: el.querySelectorAll('.lion-reward-item'),
      slidesPerView: 1,
      breakpoints: {
        '(min-width: 768px)': {
          slidesPerView: 2
        },
        '(min-width: 901px)': {
          slidesPerView: 3
        },
        '(min-width: 1201px)': {
          slidesPerView: 3
        }
      },
      created: function created(instance) {
        if (next) {
          next.addEventListener('click', function () {
            instance.next();
          });
        }

        if (prev) {
          prev.addEventListener('click', function () {
            instance.prev();
          });
        }
      },
      move: function move(instance) {
        updateArrows(instance, instance.details().slidesPerView);
      },
      mounted: function mounted(instance) {
        setTimeout(function () {
          updateArrows(instance, instance.details().slidesPerView);
        }, 25);
      }
    });
  }

  function updateArrows(carousel, slidesPerView) {
    var isFirstSlide = carousel.details().relativeSlide === 0;
    isFirstSlide ? prev.classList.add('car-Indicators_Prev-disabled') : prev.classList.remove('car-Indicators_Prev-disabled');

    var isLastSlide = carousel.details().relativeSlide === el.querySelectorAll('.lion-reward-item').length - slidesPerView;
    isLastSlide ? next.classList.add('car-Indicators_Next-disabled') : next.classList.remove('car-Indicators_Next-disabled');
  }
}